import script from "./input-violation.vue?vue&type=script&setup=true&lang=js"
export * from "./input-violation.vue?vue&type=script&setup=true&lang=js"

import "./input-violation.vue?vue&type=style&index=0&id=6cd4812c&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd4812c"]])

export default __exports__